// import external dependencies
import 'jquery';

window.jQuery = window.$;

// Import everything from autoload
import './autoload/_bootstrap.js'


// import plugins
import Swiper from "swiper";
import Metaview from './plugins/metaview';
import Fancy from './plugins/fancybox/core';
import Full from './plugins/fancybox/fullscreen';
import Media from './plugins/fancybox/media';
import Thumb from './plugins/fancybox/thumbs';
import Readmore from './plugins/readmore';


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import Downloads from './routes/downloads';
import home from './routes/home';
import aboutUs from './routes/about';
import aboutLang from './routes/aboutlang';
import Product from './routes/product';
import Projects from './routes/projects';
import Header from './components/header';





/** Populate Router instance with DOM routes */
const routes = new Router({


  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  aboutLang,


  Header,


});

// Load Events
jQuery(document).ready(() => routes.loadEvents());





// WEBPACK FOOTER //
// ./scripts/main.js